import { type ReactNode } from 'react';
import { TopNav } from './TopNav';

/**
 * Wraps a route's content with the persistent TopNav. Use everywhere except
 * /login (where the nav would be a distraction during the auth flow).
 */
export function NavLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-dvh flex flex-col">
      <TopNav />
      <div className="flex-1">{children}</div>
    </div>
  );
}
